<template>
    <component :is="component" v-bind="$attrs" />
</template>
<script setup>
import { computed, resolveComponent } from '#imports';

const props = defineProps({
    formType: {
        type: String,
        required: false,
        default: 'grouporder',
    },
});

defineOptions({
    name: 'GroupOrder',
    inheritAttrs: false,
});

const component = computed(() => {
    switch (props.formType) {
        case 'munkkimellakka':
            return resolveComponent('BlocksMunkkimellakkaForm');

        default:
            return resolveComponent('BlocksGroupOrderForm');
    }
});
</script>
